/*
This js file is made to insert a custom javascript source that uses the correct channel according to the product group.
Include this as a javascript source in the TDF of any page using Google AutoComplete to correctly record the proper channel information
provided by a premium account.
 */

var insertAutoCompleteSource = insertAutoCompleteSource || {};

insertAutoCompleteSource.initialize = function() {
	ap.consoleInfo("insertAutoCompleteSource initialize!");
	var field = page.getField("ProductGroup");
	if (field == null) {
		field = page.getField("LocationHiddenProductGroup");
	}
	if (field) {
		value = field.getValue();
		var baseUrl = document.getElementById("autoCompleteUrl").src;
		var JSLink = baseUrl+"&channel="+value;
		document.getElementById("autoCompleteUrl").src=JSLink;
	}
};